/* eslint-disable @typescript-eslint/no-unused-vars*/

import { useStyles } from './Thumb.styles';

const Thumb = ({
  children: _children,
  'aria-valuenow': valueNow,
  'aria-valuetext': valueText,
  style,
  ...props
}: any) => {
  const classes = useStyles();
  const label = (valueText || valueNow) as JSX.Element | string | number;

  return (
    <span css={classes.root} style={style}>
      <span css={classes.thumb} {...props} aria-valuetext={valueText}>
        <span className="thumb--active-background" />
      </span>
      <span css={classes.tooltip} className="thumb--tooltip">
        <span className="thumb--tooltip-label">{label}</span>
        <svg viewBox="0 0 26 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 18C14.25 18 25.5 9.25 25.5.5H.5C.5 9.25 11.75 18 13 18Z" />
        </svg>
      </span>
    </span>
  );
};

export default Thumb;
